export const cifLy = ["301 151","<g fill-rule='nonzero' fill='none'><path fill='#239E46' d='M.5.5h300v150H.5z'/><path fill='#000' d='M.5.5h300V113H.5z'/><path fill='#E70013' d='M.5.5h300V38H.5z'/><path d='M163.76 62.24c-7.323-5.226-17.496-3.526-22.722 3.798-5.226 7.323-3.526 17.496 3.798 22.722a16.29 16.29 0 0018.925 0c-7.323 7.321-19.195 7.32-26.516-.004-7.322-7.323-7.32-19.195.004-26.516 7.32-7.32 19.189-7.32 26.511 0zm-4.14 13.26l25.23-8.19-15.6 21.45V62.24l15.6 21.45-25.23-8.19z' fill='#FFF'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-ly.js
// module id = null
// module chunks = 